import { all } from "redux-saga/effects";
import { watchFilterChange } from "./filters";
import { watchKeywordTriggeredBanner } from "./keywordTriggeredBanner";
import { watchResultMore } from "./result";
import { watchFormSubmit } from "./search";
import { watchSuggestions } from "./suggestions";
import { watchWebcode } from "./webcode";

export default function* rootSaga() {
  yield all([
    watchFilterChange(),
    watchFormSubmit(),
    watchKeywordTriggeredBanner(),
    watchResultMore(),
    watchSuggestions(),
    watchWebcode(),
  ]);
}
